import React from "react";
import { RECIPIENT_TYPES, SELECTABLE_RECIPIENT_TYPES, PERCENT_OPTIONS } from "../constants/recipientTypes";

// Satu kartu recipient. Murni presentational — semua perubahan diangkat ke
// parent lewat callback. CEA readonly (kategori & persen dikunci ke discount).
const RecipientCard = ({
  recipient,
  index,
  usedTypes,
  picEmail,
  studentNames,
  onChange,
  onRemove,
}) => {
  const isCEA = recipient.type === RECIPIENT_TYPES.CEA;

  // Dropdown kategori hanya menampilkan tipe yang belum dipakai + tipe sendiri.
  const availableTypes = SELECTABLE_RECIPIENT_TYPES.filter(
    (t) => t === recipient.type || !usedTypes.includes(t),
  );

  const card = {
    border: "1px solid #e6e6e6",
    borderRadius: "12px",
    padding: "18px",
    background: isCEA ? "#fbfbfd" : "#fff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    position: "relative",
  };
  const label = { fontSize: "12px", fontWeight: 600, color: "#666", marginBottom: "6px", display: "block" };

  return (
    <div style={card}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px" }}>
        <span style={{ fontSize: "13px", fontWeight: 700, color: "#231f20" }}>
          Recipient {index + 1}
          {isCEA && (
            <span style={{ marginLeft: "8px", fontSize: "11px", fontWeight: 600, color: "#fb3104", background: "#fff0ee", padding: "2px 8px", borderRadius: "20px" }}>
              AUTO · follows discount
            </span>
          )}
        </span>
        {!isCEA && (
          <button
            type="button"
            onClick={() => onRemove(index)}
            style={{ border: "none", background: "none", color: "#c0392b", fontSize: "18px", cursor: "pointer", lineHeight: 1 }}
            title="Remove recipient"
          >
            ×
          </button>
        )}
      </div>

      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
        {/* Category */}
        <div style={{ flex: "1 1 180px" }}>
          <label style={label}>Category</label>
          {isCEA ? (
            <div style={{ padding: "9px 12px", border: "1px solid #eee", borderRadius: "8px", background: "#f4f4f4", fontSize: "14px", fontWeight: 600, color: "#888" }}>
              CEA (readonly)
            </div>
          ) : (
            <select
              className="form-select"
              value={recipient.type}
              onChange={(e) => onChange(index, { type: e.target.value })}
              style={{ fontSize: "14px" }}
            >
              {availableTypes.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          )}
        </div>

        {/* Percentage — kelipatan 25 */}
        <div style={{ flex: "0 0 120px" }}>
          <label style={label}>Percentage</label>
          {isCEA ? (
            <div style={{ padding: "9px 12px", border: "1px solid #eee", borderRadius: "8px", background: "#f4f4f4", fontSize: "14px", fontWeight: 600, color: "#888" }}>
              {recipient.percent}%
            </div>
          ) : (
            <select
              className="form-select"
              value={recipient.percent}
              onChange={(e) => onChange(index, { percent: Number(e.target.value) })}
              style={{ fontSize: "14px" }}
            >
              {PERCENT_OPTIONS.map((p) => (
                <option key={p} value={p}>{p}%</option>
              ))}
            </select>
          )}
        </div>
      </div>

      {/* Detail per kategori */}
      {recipient.type === RECIPIENT_TYPES.PIC && (
        <p style={{ margin: "12px 0 0", fontSize: "12.5px", color: "#777" }}>
          Payment link goes to PIC email: <strong>{picEmail || "—"}</strong>
        </p>
      )}

      {recipient.type === RECIPIENT_TYPES.STUDENT && (
        <div style={{ margin: "12px 0 0" }}>
          <p style={{ margin: 0, fontSize: "12.5px", color: "#777" }}>
            Each student receives their own payment link (full share, not divided):
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "6px" }}>
            {studentNames.length === 0 ? (
              <span style={{ fontSize: "12px", color: "#aaa" }}>No students in registration</span>
            ) : (
              studentNames.map((n) => (
                <span key={n} style={{ fontSize: "12px", background: "#eef1ff", color: "#3a45c9", padding: "3px 10px", borderRadius: "20px" }}>
                  {n}
                </span>
              ))
            )}
          </div>
        </div>
      )}

      {recipient.type === RECIPIENT_TYPES.OTHER_EMAIL && (
        <div style={{ margin: "12px 0 0" }}>
          <label style={label}>Recipient Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="name@example.com"
            value={recipient.email || ""}
            onChange={(e) => onChange(index, { email: e.target.value })}
            style={{ fontSize: "14px" }}
          />
        </div>
      )}

    </div>
  );
};

export default RecipientCard;
